import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import {toast} from 'react-toastify';
import {PulseLoader} from '../';
import Api from '../../../utils/api';

import {IMAGE_UPLOAD} from '../../../configs/apis';
import {IMAGES_ACCEPT_MIMES, MAX_FILE_SIZES} from '../../../configs/constants';
import {
  imageExtensions,
  noImageSelected,
  fileTypeNotSupportedError,
  fileSizeExceedError,
} from '../../../configs/messages';

export default class FileUploader extends Component {
  static propTypes = {
    selectedMedia: PropTypes.string,
    styles: PropTypes.bool,
    modificator: PropTypes.string,
    onFileUploaded: PropTypes.func.isRequired,
    editMode: PropTypes.bool,
  };

  static defaultProps = {
    selectedMedia: null,
    styles: true,
    modificator: '',
    editMode: true,
  };

  constructor(props) {
    super(props);
    const {selectedMedia, styles, modificator} = props;

    this.state = {
      selectedMedia,
      styles,
      modificator,
    };
  }

  componentWillReceiveProps({selectedMedia}) {
    this.setState({selectedMedia});
  }

  onDrop = (files) => {
    const {onFileUploaded} = this.props;
    const formData = new FormData();
    if (isEmpty(files)) {
      toast.error(fileTypeNotSupportedError);
      return;
    }

    const file = files[0];

    if (file.size > MAX_FILE_SIZES) {
      toast.error(fileSizeExceedError);
      return;
    }

    formData.append('image', file);
    this.setState({isLoading: true});

    Api.post(IMAGE_UPLOAD, formData)
      .then((res) => {
        this.setState({selectedMedia: res.url, isLoading: false});
        onFileUploaded(res.url);
      })
      .catch(() => {
        this.setState({isLoading: false});
      });
  }

  renderMedia = () => {
    const {selectedMedia} = this.state;
    return (
      <img className="file-uploader__dropzone-img" src={selectedMedia} alt=""/>
    );
  };

  render() {
    const {selectedMedia, styles, modificator, isLoading} = this.state;
    const {editMode} = this.props;
    const accept = IMAGES_ACCEPT_MIMES.join(',');

    return (
      <div
        className={classnames('file-uploader', {
          'file-uploader__no-styles': !styles,
          [`file-uploader_${modificator}`]: Boolean(modificator),
        }
        )}
      >
        <Dropzone
          multiple={false}
          accept={accept}
          className="file-uploader__dropzone"
          onDrop={this.onDrop}
          disabled={!editMode}
        >
          {!selectedMedia &&
            <div className="file-uploader__txt">
              <div>{noImageSelected}</div>
              <div>{imageExtensions}</div>
            </div>
          }
          {selectedMedia && this.renderMedia()}
          {isLoading &&
          <div className="file-uploader__loader">
            <PulseLoader margin="4px"/>
          </div>}
        </Dropzone>
      </div>
    );
  }
}
